import { Pipe, PipeTransform } from '@angular/core';

const nonResizableClasses = 'col-3 order-3';

@Pipe({
  name: 'infoColumnLayout',
  pure: true
})
export class InfoColumnLayoutPipe implements PipeTransform {
  transform(resizableMode: boolean): string {
    const classes: string[] = [];

    if (resizableMode) {
      classes.push('col-auto');
    } else {
      classes.push(nonResizableClasses);
    }

    return classes.join(' ');
  }
}
